import React, { ChangeEvent } from 'react';
import SignaturePad from 'react-signature-canvas';
import { SignMode } from '../types';

interface SignatureFieldProps {
  signed: string;
  signedSignType: string;
  signMode: SignMode;
  signText: string;
  onChangeSignText: (value: string) => void;
  setSigPad: (ref: any) => void;
  onDrawEnd: () => void;
}

const SignatureField = ({
  signed,
  signedSignType,
  signMode,
  signText,
  onChangeSignText,
  setSigPad,
  onDrawEnd,
}: SignatureFieldProps) => {
  if (signed !== '') {
    if (signedSignType === 'text') {
      return (
        <div className="signatureCanvas__signText">
          <input
            value={signed}
            className="signatureCanvas__signText__FontStyle"
            type="text"
            disabled
          />
        </div>
      );
    }

    if (signedSignType === 'signed') {
      return (
        <div
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            width: '80%',
            padding: 5,
          }}
        >
          <img
            alt=""
            src={signed}
            style={{
              minWidth: '1%',
              maxWidth: '70%',
              minHeight: '1%',
              maxHeight: '80%',
              padding: 5,
            }}
          />
        </div>
      );
    }

    return null;
  }

  if (signMode === SignMode.Draw) {
    return (
      <SignaturePad
        canvasProps={{ className: 'signatureCanvas__sigPad' }}
        ref={(ref: any) => setSigPad(ref)}
        onEnd={onDrawEnd}
      />
    );
  }

  return (
    <div className="signatureCanvas__signText">
      <input
        value={signText}
        className="signatureCanvas__signText__FontStyle"
        type="text"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChangeSignText(e.target.value)
        }
      />
    </div>
  );
};

export default SignatureField;
